module.exports = __webpack_public_path__ + "media/icons/color-select-55cae5ba.png";